export enum PlanTypeEnum {
  /// <summary>
  /// consumption
  /// </summary>
  Consumption = 1,
  /// <summary>
  /// package
  /// </summary>
  Package = 2,
}

export enum CompanyStateEnum {
  Active = 1,
  Inactive = 2,
}
